import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowRight, Storefront } from "@phosphor-icons/react";

export default function JoinCTA() {
  return (
    <section
      id="join"
      data-testid="join-cta-section"
      className="relative overflow-hidden brand-gradient text-white"
    >
      <div className="absolute -top-32 -left-24 h-[420px] w-[420px] rounded-full bg-white/15 blur-3xl" />
      <div className="absolute -bottom-40 -right-16 h-[380px] w-[380px] rounded-full bg-black/15 blur-3xl" />

      <div className="relative max-w-[1400px] mx-auto px-6 md:px-12 py-24 md:py-32 text-center">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
        >
          <p className="overline text-white/80 mb-5 flex items-center justify-center gap-2">
            <Storefront size={14} weight="duotone" />
            Run a local spot?
          </p>
          <h2
            className="font-display font-extrabold text-4xl md:text-6xl tracking-tighter leading-[0.95]"
            data-testid="join-cta-headline"
          >
            Your shop. Their phone. <span className="text-white/70">Sorted.</span>
          </h2>
          <p className="mt-6 text-lg md:text-xl text-white/85 max-w-2xl mx-auto leading-relaxed">
            Free to join. One low fixed percentage. Orders from people who
            already know your name.
          </p>
          <div className="mt-10">
            <Link
              to="/partner"
              data-testid="join-cta-btn"
              className="group inline-flex items-center gap-2 px-8 py-4 rounded-full bg-white text-zinc-900 font-semibold shadow-xl shadow-black/20 hover:-translate-y-0.5 hover:shadow-2xl transition-all"
            >
              Become a partner
              <ArrowRight size={18} weight="bold" className="group-hover:translate-x-0.5 transition-transform" />
            </Link>
            <p className="mt-5 text-sm text-white/70">
              Real local support, from people who shop here too.
            </p>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
